export const sessionsOnMessage = (receivedData) => {
  switch (receivedData.event) {
    case "update_signer_appointment":
      return { type: "UPDATE_SIGNER_RON_DATE", payload: receivedData?.data };
    default:
      return;
  }
};
